import { ApiService, FileUploadService } from "../../../config/apiServices";
import {
  GOVT_ORDER_ADMIN_URL,
} from "../../../config/adminUrlConfig";

export const getGovtOrders = (page = 1, search = "") => {
  let url = `${GOVT_ORDER_ADMIN_URL}?page=${page}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  return ApiService.get(url);
};

export const createGovtOrder = (formData) =>
  FileUploadService.post(GOVT_ORDER_ADMIN_URL, formData);

export const updateGovtOrder = (id, formData) =>
  FileUploadService.post(`${GOVT_ORDER_ADMIN_URL}/${id}`, formData);

export const deleteGovtOrder = (id) =>
  ApiService.delete(`${GOVT_ORDER_ADMIN_URL}/${id}`);

export const toggleGovtOrderStatus = (id) =>
  ApiService.get(`${GOVT_ORDER_ADMIN_URL}/${id}/toggle-status`);
